import { render, staticRenderFns } from "./ContractWorkOrders.vue?vue&type=template&id=5971d98f"
import script from "./ContractWorkOrders.vue?vue&type=script&lang=ts"
export * from "./ContractWorkOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports